/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ComponentProps, ComponentType, FC, ReactNode } from 'react';
import { lazy, Suspense } from 'react';

/** Code-split a component behind its own Suspense so first use never suspends the host page. */
export function lazyComponent<T extends ComponentType<any>>(
  loader: () => Promise<{ default: T }>,
  fallback: ReactNode = null,
): FC<ComponentProps<T>> {
  const Lazy = lazy(loader) as ComponentType<any>;
  const Wrapped: FC<ComponentProps<T>> = (props) => (
    <Suspense fallback={fallback}>
      <Lazy {...props} />
    </Suspense>
  );
  return Wrapped;
}
